import { combineReducers } from '@reduxjs/toolkit';

import ui from './ui';
import modals from './modals';
import isConnected from './isConnected';

/**
 * @typedef {{
 *   isConnected: import('./isConnected').IsConnectedState,
 *   modals: import('./modals').ModalsState,
 *   ui: import('./ui').UIState,
 * }} AppState
 */

export default combineReducers({
  isConnected,
  modals,
  ui,
});
